<script setup>
const props = defineProps({
  title: {
    type: String,
    default: undefined,
  },
  image: {
    type: Object,
    default: () => ({ desktop: null }),
  },

  buttonScrollId: {
    type: String,
    default: undefined,
  },
});

function scrollToId() {
  const element = document.getElementById(props.buttonScrollId);
  safeScrollToElement(element, false);
}
</script>

<template>
  <div class="ctr-vacancies-referral-head container">
    <CPicture
      v-if="image"
      class="ctr-vacancies-referral-head__img"
      v-bind="image"
      :alt="title"
    />

    <div class="ctr-vacancies-referral-head__info">
      <div class="ctr-vacancies-referral-head__wrapper">
        <div v-if="title" class="ctr-vacancies-referral-head__title">
          <h1
            class="ctr-vacancies-referral-head__font ctr-vacancies-referral-head__font--title"
          >
            {{ $tp(title) }}
          </h1>
        </div>

        <ButtonsUnderlined
          class="ctr-vacancies-referral-head__button"
          :title="$t('vacancies.goToVacancies')"
          icon="link-arrow-down"
          @click="scrollToId"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.ctr-vacancies-referral-head {
  $parent: &;

  position: relative;

  &__img {
    position: absolute;
    top: 0;
    right: 0;
    width: em(1271);
    z-index: -1;

    @include media-breakpoint-down(sm) {
      top: em(-58);
      width: em(352);
    }
  }

  &__info {
    @include media-breakpoint-up(sm) {
      padding-bottom: em(206);
      //border-bottom: 1px solid $color-red-1;
    }
  }

  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: em(50);

    @include media-breakpoint-up(sm) {
      min-height: em(672);
    }

    @include media-breakpoint-down(sm) {
      gap: em(70);
    }
  }

  &__title {
    padding-top: em(92);

    @include media-breakpoint-up(sm) {
      max-width: em(1075);
    }

    @include media-breakpoint-down(sm) {
      padding-top: em(35);
      min-height: em(325);
    }
  }

  &__button {
    @include media-breakpoint-up(sm) {
      margin-top: auto;
      width: em(521);
    }
  }

  &__font {
    &--title {
      font-size: em(128);
      line-height: 1;

      @include media-breakpoint-down(sm) {
        font-size: em(40);
      }
    }
  }
}
</style>
